import OemBrandSection from 'pages/CatalogPage/IAM/SubcategorySection/SparePartsSection/OemBrandSection/OemBrandSection';

export default OemBrandSection;
